import { render, staticRenderFns } from "./g-location.vue?vue&type=template&id=6e4b8232&scoped=true"
import script from "./g-location.vue?vue&type=script&lang=ts"
export * from "./g-location.vue?vue&type=script&lang=ts"
import style0 from "./g-location.vue?vue&type=style&index=0&id=6e4b8232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4b8232",
  null
  
)

export default component.exports